// src/components/Header/index.jsx
import { Layout, Menu, Avatar, Space, Dropdown, message } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { 
  LogoutOutlined
} from '@ant-design/icons';

const { Header: AntHeader } = Layout;

const Header = () => {
  const navigate = useNavigate();
  const user = localStorage.getItem('user') 
    ? JSON.parse(localStorage.getItem('user')) 
    : null;
  const isLoggedIn = !!user;
  
  // 检查登录状态，未登录跳转到登录页面
  const checkAuth = (actionName = '此操作') => {
    if (!isLoggedIn) {
      message.warning(`请先登录${actionName}`);
      navigate('/auth');
      return false;
    }
    return true;
  };
  
  // 处理写文点击
  const handleWriteClick = () => {
    if (checkAuth('写文章')) {
      navigate('/write');
    }
  };
  
  // 处理"我的"点击
  const handleMineClick = () => {
    if (checkAuth('查看个人主页')) {
      navigate('/');
    }
  };
  
  // 处理头像点击
  const handleAvatarClick = () => {
    if (isLoggedIn) {
      // 已登录：显示下拉菜单（由Dropdown组件处理）
    } else {
      message.warning('请先登录');
      navigate('/auth');
    }
  };
  
  // 退出登录
  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    message.success('已退出登录');
    navigate('/auth');
  };
  
  // 菜单项
  const items = [
    { key: 'home', label: <Link to="/postcard">首页</Link> },
    { 
      key: 'write', 
      label: <span onClick={handleWriteClick} style={{ cursor: 'pointer' }}>写文</span>
    },
    { key: 'archive', label: <Link to="/archive">归档</Link> },
    { key: 'about', label: <Link to="/about">关于</Link> },
    { 
      key: 'mine', 
      label: <span onClick={handleMineClick} style={{ cursor: 'pointer' }}>我的</span>
    },
  ];

  // 头像下拉菜单项（仅登录用户显示）
  const avatarMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ];

  return (
    <AntHeader style={{ 
      position: 'fixed', 
      width: '100%', 
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
      <div style={{ color: 'white', fontSize: 18, flexShrink: 0 }}>
        My Blog
      </div>
      
      <div style={{ 
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        margin: '0 40px'
      }}>
        <Menu
          theme="dark"
          mode="horizontal"
          items={items}
          style={{ 
            borderBottom: 'none',
            width: 'auto'
          }}
        />
      </div>
      
      <div style={{ color: 'white', flexShrink: 0 }}>
        {isLoggedIn ? (
          <Dropdown 
            menu={{ items: avatarMenuItems }} 
            placement="bottomRight"
            trigger={['click']}
          >
            <Space style={{ cursor: 'pointer' }} onClick={handleAvatarClick}>
              <span>{user.name}</span>
              <Avatar 
                size="small" 
                style={{ backgroundColor: '#1890ff' }}
              >
                {user.name.charAt(0)}
              </Avatar>
            </Space>
          </Dropdown>
        ) : (
          <Space 
            onClick={handleAvatarClick} 
            style={{ cursor: 'pointer' }}
          >
            <span>登录</span>
            <Avatar size="small" style={{ backgroundColor: '#999' }}>
              未
            </Avatar>
          </Space>
        )}
      </div>
    </AntHeader>
  );
};

export default Header;